import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  ViewChild,
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { IonicPage, NavParams, ViewController } from "ionic-angular";
import { PainSiteService } from "../../../components/configurable/cards/pain-site-card/pain-site.service";

@IonicPage()
@Component({
  selector: "wound-modal",
  templateUrl: "wound-modal.html",
})
export class WoundModalPage implements AfterContentChecked {
  @ViewChild("sidebar") sidebar;
  config;
  currentStep: number = 1;
  painService: PainSiteService;
  tools: string[];
  cardId: string;

  constructor(
    public viewCtrl: ViewController,
    public navParams: NavParams,
    private cdr: ChangeDetectorRef,
    public translatePipe: TranslateService
  ) {
    this.config = navParams.get("config");
  }

  ngOnInit(): void {
    this.painService = new PainSiteService(this.config, this.translatePipe);
    this.tools = this.config.tools;
    this.cardId = this.config.id;
  }

  ngAfterContentChecked(): void {
    this.cdr.detectChanges();
  }

  isStepComplete() {
    return this.sidebar.isStepComplete();
  }

  nextStep() {
    // this.sidebar.nextStep();
    if (this.sidebar.isStepComplete()) {
      if (this.sidebar.points && this.sidebar.points.length > 0) {
        this.sidebar.points[0].cardId = this.config.id;

        if (this.cardId !== "CL010.3") {
          for (let item of Object.keys(this.sidebar.points[0]["woundType"])) {
            if (this.sidebar.points[0]["woundType"][item] == false) {
              delete this.sidebar.points[0]["woundType"][item];
            }
          }

          for (let item of Object.keys(this.sidebar.points[0]["drainage"])) {
            if (this.sidebar.points[0]["drainage"][item] == false) {
              delete this.sidebar.points[0]["drainage"][item];
            }
          }
        }

        if (this.currentStep < 3) {
          if (
            this.sidebar.points[0].severity === 0 &&
            this.cardId === "CL010.3"
          ) {
            if (this.sidebar.points[0].painTool === "flacc") {
              this.sidebar.points[0].unableToDetermine = true;
            } else {
              this.sidebar.points[0].noPain = true;
            }
            this.sidebar.points[0].category =
              this.translatePipe.instant("painAssessed");
            this.sidebar.points[0].name = "";
          } else {
            this.sidebar.points[0].unableToDetermine = false;
            this.sidebar.points[0].noPain = false;
          }
          this.currentStep++;
        } else {
          if (
            this.sidebar.points[0].severity === 0 &&
            this.cardId === "CL010.3" &&
            this.sidebar.points[0].painTool === "flacc"
          ) {
            this.sidebar.points[0].name =
              this.translatePipe.instant("unableToDetermine");
          }

          if (
            this.sidebar.points[0].unspecifiedLocation &&
            this.cardId === "CL010.3"
          ) {
            this.sidebar.points[0].category =
              this.translatePipe.instant("body");
            this.sidebar.points[0].name =
              this.translatePipe.instant("generalizedPain");
          }
          this.onSubmit();
        }
      }
      this.sidebar.isStepComplete();
    }
  }

  previousStep() {
    // this.sidebar.previousStep();
    if (this.currentStep > 1) {
      this.currentStep--;
    }
  }

  onDismiss() {
    this.viewCtrl.dismiss();
  }

  onSubmit() {
    this.viewCtrl.dismiss(this.painService.getAllPointData());
  }

  getBtnText() {
    if (this.sidebar.points.length > 0) {
      if (this.currentStep === 3) {
        return "submit";
      } else {
        return "next";
      }
    } else {
      return "next";
    }
  }

  getBtnColor() {
    if (this.sidebar.points.length > 0) {
      if (this.currentStep === 3) {
        return "success";
      } else {
        return "primary";
      }
    } else {
      return "primary";
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/assessment/wound-modal/wound-modal.ts